import { Directive, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[mdDisableInput]',
})
export class DisableInputDirective implements OnChanges {
  // @ts-expect-error
  @Input() mdDisableInput: boolean;

  // @ts-expect-error
  @HostBinding('class.input_disabled') disabledStyle: boolean;
  // @ts-expect-error
  @HostBinding('attr.disabled') disabledAttr: true | null;
  // @ts-expect-error
  @HostBinding('attr.readonly') readOnly: boolean;

  ngOnChanges(changes: SimpleChanges) {
    this.disabledStyle = this.mdDisableInput;
    this.disabledAttr = this.mdDisableInput || null;
    // @ts-expect-error
    this.readOnly = this.mdDisableInput || null;
  }
}
